export const hy = {
    LEFT: 'Ձախ: անցումը նախորդ օրը:',
    RIGHT: 'Right: անցումը դեպի հաջորդ օրվան:',
    DOWN: 'Ներքեւ: գնալ հաջորդ տողում:',
    UP: 'Վեր: գնալ նախորդ բար.',
    PGUP: 'Վեր: շարժվող նախորդ ամսվա.',
    PGDOWN: 'PgDown: գնալ հաջորդ ամիս:',
    HOME: 'Տները: անցումը նախորդ տարի.',
    END: 'Վերջ: տեղափոխել հաջորդ տարի:',
    ESC: 'Эку/այսօր/փակել: փակել օրացույց. Հրահանգներ',
    TITLE: 'Ստեղնաշար '
};
